var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRisk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E4555",
    d: "M17.19 15.995l4.68-3.41c-1.287-1.777-3.102-3.1-5.184-3.78l-1.787 5.518c.92.302 1.722.887 2.292 1.672z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#173042",
    d: "M18.07 18.7h5.782c.003-2.198-.691-4.339-1.981-6.115l-4.68 3.41c.572.785.88 1.732.88 2.705z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#455968",
    d: "M13.482 14.096c.481 0 .96.076 1.418.227l1.786-5.518c-2.083-.678-4.326-.678-6.409 0l1.786 5.518c.458-.15.937-.227 1.419-.227z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#74838E",
    d: "M9.772 15.995l-4.68-3.41c-1.29 1.776-1.984 3.917-1.981 6.115h5.781c0-.973.307-1.92.88-2.705z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5D6E7B",
    d: "M12.063 14.323l-1.786-5.518c-2.083.68-3.898 2.003-5.185 3.78l4.68 3.41c.57-.785 1.371-1.37 2.291-1.672z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#173042",
    d: "M14.296 18.962c.106-.452-.173-.903-.622-1.01-.45-.106-.9.174-1.006.625-.106.451.173.903.622 1.01.45.105.9-.174 1.006-.625z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#173042",
    d: "M13.481 12.929l.418 5.77h-.925l.42-5.77c.001-.01.007-.02.015-.026.008-.007.018-.01.028-.01.01 0 .02.003.029.01.008.006.013.016.015.026z",
    opacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#173042",
    d: "M13.526 12.998l.417 5.77h-.924l.418-5.77c0-.012.004-.024.013-.032.008-.008.02-.013.031-.013.012 0 .023.005.032.013.008.008.013.02.013.032z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#173042",
    d: "M13.481 19.24c-.094 0-.187-.028-.265-.08-.079-.054-.14-.128-.176-.216-.037-.088-.046-.184-.028-.277.019-.093.064-.179.131-.246s.152-.113.245-.131c.093-.018.189-.009.276.027.088.037.162.098.215.177.052.079.08.172.08.266 0 .128-.05.25-.14.34-.09.09-.211.14-.338.14z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#173042",
    d: "M13.89 18.038l-.364-5.04c-.001-.012-.006-.022-.015-.03-.008-.008-.019-.012-.03-.012v6.65c.185 0 .364-.061.51-.174.147-.113.252-.272.299-.451.046-.18.033-.37-.04-.54-.072-.17-.198-.312-.36-.403z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRisk);
export default ForwardRef;